import { DefaultTag } from "@/shared/Components";
import type { FC, ReactNode } from "react";
import styles from "./styles.module.scss";

type Props = {
  value?: ReactNode;
  onRemove?: () => void;
};

export const Tag: FC<Props> = ({ onRemove, value }) => {
  return (
    <div className={styles.root}>
      <DefaultTag onClose={onRemove} closable className={styles.tag}>
        <div className={styles["tag-overflow"]}>{value}</div>
      </DefaultTag>
    </div>
  );
};
